import { environment } from '../../../../environments/environment';

export class ConfigModel {
    apiUrl: string;
    externalWebsiteURL: string;
    accesswireEditingDelay: number;
    intercomID: string;
    brandGUID?: string;
    brandingRefresh: boolean;
    googleTagId: string;
    // default to prod value for backwards compatibility
    thirdPartyEnabledAccounts: number[] = [];
    bmieUrl: string;
    contentLibraryUrl: string;
    sessionTimeoutInMinutes: number;

    constructor() {
        this.apiUrl = environment.apiGatewayUrl;
        this.externalWebsiteURL = environment.newsroomExternalSiteBaseUrl;
        this.accesswireEditingDelay = environment.accesswireEditingDelay;
        this.intercomID = environment.intercomID;
        this.googleTagId = environment.googleTagId;
        this.thirdPartyEnabledAccounts = environment.thirdPartyEnabledAccounts ?? [];
        this.bmieUrl = environment.bmieUrl;
        this.sessionTimeoutInMinutes = environment.sessionTimeoutInMinutes;
        this.contentLibraryUrl = environment.contentLibraryUrl;
    }
}
